import React from "react";
import { useLocation } from "react-router-dom";
import { UserAuth } from "../../context/AuthContext.js";
import { ChevronRight, Users, Shield, LogOut } from "lucide-react";
import { cn } from "../../lib/utils";

const MenuItem = ({ title, path, icon: Icon, isSubMenu, activeBg, padding, isActive }) => {
  const location = useLocation();
  const isCurrentPath = location.pathname === path;

  return (
    <div
      className={cn(
        "rounded-md transition-colors",
        isCurrentPath && "bg-indigo-200",
        activeBg && "bg-indigo-100",
        isSubMenu ? "ml-4" : ""
      )}
    >
      <a
        href={path}
        className={cn(
          "flex items-center gap-3 px-4 py-3 text-gray-700 hover:text-gray-900 rounded-md transition-colors",
          isCurrentPath && "text-gray-900 font-medium",
          padding
        )}
      >
        {typeof Icon === "string" ? (
          <img src={Icon} alt="" className="w-5 h-5" />
        ) : (
          <Icon className="w-5 h-5" />
        )}
        {/* Adjusted font size */}
        <span className="text-base font-medium">{title}</span>
      </a>
    </div>
  );
};

const SideBar = ({ roles, isLoading }) => {
  const { handlerLogout, user } = UserAuth();
  const { pathname } = useLocation();

  const dynamicMenu = roles?.map((role, index) => ({
    key: `role-${index}`,
    title: role.rolename,
    path: `/admin/roles/${encodeURIComponent(role.rolename)}`,
    icon: ChevronRight,
    isSubMenu: true,
    padding: "py-2 px-3",
  }));

  const menu = [
    {
      key: 2,
      title: "User Management",
      path: "/admin/users",
      icon: Users,
    },
    {
      key: 3,
      title: "Role Management",
      path: "/admin/roles",
      icon: Shield,
      listItems: isLoading ? [] : dynamicMenu,
    },
  ];

  return (
    <div className="flex flex-col h-full bg-white border-r border-gray-200">
      {/* User Profile Section */}
      <div className="p-4 border-b border-gray-300 bg-blue-50">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-blue-200 flex items-center justify-center">
            <span className="text-blue-700 font-medium text-sm">
              {user?.email?.[0]?.toUpperCase() || "J"}
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-gray-800 font-medium truncate max-w-[180px] text-base">
              {user?.email || "jay foster"}
            </span>
          </div>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1 p-2 space-y-1 bg-gray-50">
        {menu.map((item) => {
          const isParentPathActive = pathname === item.path;
          return (
            <div key={`menu-${item.key}`} className="space-y-1">
              <MenuItem {...item} key={item.key} />
              {item.listItems?.map((listItem) => (
                <MenuItem
                  {...listItem}
                  key={listItem.key}
                  activeBg={isParentPathActive}
                />
              ))}
            </div>
          );
        })}
      </nav>

      {/* Sign Out Button */}
      <button
        onClick={handlerLogout}
        className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:text-gray-900 hover:bg-blue-100 transition-colors m-2 rounded-md"
      >
        <LogOut className="w-5 h-5 text-blue-600" />
        <span className="text-base font-medium">Sign out</span>
      </button>
    </div>
  );
};

export default SideBar;
